import { Box, Tooltip } from "@mui/joy";
import { ApiRouteInline } from "griptonite-api-client";
import { useRef } from "react";

import getCompetitionRouteDisplay from "@/utils/getCompetitionRouteDisplay";

import { Route } from "../../core/types";
import { RouteCircle } from "../RouteCircle";
import TagWarningIcon from "../TagWarningIcon";

export const RouteNameText = ({
  route,
  competitionCategoryUuid,
}: {
  route: Route | Partial<Route>;
  competitionCategoryUuid?: string;
}) => {
  if (route.climbType === "BOULDER") {
    if (route.circuit) {
      const shortPart = `${route.circuit.number || route.gradeValue || "?"}`;
      if (route.name) {
        if (shortPart === "?") {
          return route.name;
        } else {
          return `${shortPart} ${route.name}`;
        }
      }
      return `${shortPart}`;
    } else {
      if (route.competitionRouteGroups?.length) {
        return getCompetitionRouteDisplay(route, {
          categoryUuid: competitionCategoryUuid,
          routeGroups: route.competitionRouteGroups,
        }).name;
      }
    }
  } else if (route.climbType === "SPORT") {
    if (route.competitionRouteGroups?.length) {
      return getCompetitionRouteDisplay(route, {
        categoryUuid: competitionCategoryUuid,
        routeGroups: route.competitionRouteGroups,
      }).name;
    }
    return route.name || route.gradeValue || "?";
  }
  return "?";
};

export const RouteName = ({
  route,
  ellipsize,
}: {
  route: Route | ApiRouteInline;
  ellipsize?: boolean;
}) => {
  const routeNameText = <RouteNameText route={route} />;
  const ref = useRef<HTMLElement>(null);

  const isEllipsized = ref.current && ref.current.offsetWidth < ref.current.scrollWidth;

  const textEl = (
    <strong
      ref={ref}
      style={{
        ...(ellipsize
          ? {
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }
          : {}),
        flex: 1,
        minWidth: 0,
      }}
      // ref={ref}
    >
      {routeNameText}
    </strong>
  );

  return (
    <Box sx={{ display: "flex", alignItems: "center", minWidth: 0 }}>
      <Box sx={{ mr: 0.5 }}>
        <RouteCircle colors={(route.colors || "#FFFFFF").split(":")} climbType={route.climbType} />
      </Box>
      {isEllipsized ? <Tooltip title={routeNameText}>{textEl}</Tooltip> : textEl}
    </Box>
  );
};

export const RouteNameCell = ({
  route,
  showTagWarning = true,
}: {
  route: Route;
  showTagWarning?: boolean;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        width: "100%",
        minWidth: 0,
      }}
    >
      {showTagWarning && route.climbType !== "SPORT" && !route.tag ? <TagWarningIcon /> : null}
      <RouteName route={route} ellipsize />
    </Box>
  );
};
